import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BoxLabelConfig, CompilationModel } from '../../../../../@models/erp/compilation';
import { ApiService } from '../../../../../@core/service/api.service';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { SpoBoxModel } from '../../../../../@models/erp/spoBox';
import { BoxDetails, LineItemModel } from '../../../../../@models/erp/lineItem';
import { EBoxLabelPriority, FinishedProductModel } from '../../../../../@models/erp/finishedProduct';
import { chunkArray, getDocumentNumber, isValidDate, mongoId } from '../../../../../@core/common/global';
import { BusinessModel } from '../../../../../@models';
import { NbToastrService } from '@nebular/theme';
import { DownloadConfig } from '../document-printer.component';
import { DatePipe } from '@angular/common';
import * as saveAs from 'file-saver';
import * as moment from 'moment';
import { TreeService } from '../../../../../@core/service/tree.service';
import { NrkWindowComponent } from '../../../shared/nrk-window/nrk-window.component';
import { PopupDocumentComponent } from '../popup-document/popup-document.component';
import { AuthGuardService } from '../../../../../@core/service/auth-guard.service';

type ShelfLifeModeType = 'standard' | 'column' | 'calc';

class SpoBoxDetail {
  public boxId: number;
  public quantity: number;
  public selected = true;
  public netWeight: number;
  public grossWeight: number;
  // public netWeight: number;
  // public grossWeight: number;
  public joints = 0;
  constructor(
    public oc: CompilationModel,
    public box: SpoBoxModel,
    public spo: CompilationModel,
    public details: BoxDetails[],
    public lineItem: LineItemModel,
    public dnLineItem: LineItemModel,
    public finishedProduct: FinishedProductModel,
    public customer: BusinessModel,
    public el?: number,
    public of?: number,
  ) {
    this.boxId = box.boxId;
    this.quantity = details.reduce((a, c) => c.quantity, 0);
    this.details.forEach(el => {
      if (!isValidDate(el.prodDate)) el.prodDate = null;
      if (!isValidDate(el.expiryDate)) el.expiryDate = null;
    });
    const width = finishedProduct?.content?.energy?.width / 1000; // mm -> m
    const length = finishedProduct?.content?.energy?.rollLength; // m
    const areaWeight = finishedProduct?.product?.weight / 1000; // g -> kg
    const quantity = details?.reduce((a, c) => a + (c?.quantity || 0), 0);
    this.netWeight = width * length * areaWeight * quantity;
    this.grossWeight = details[0]?.grossWeight;
    this.joints = details.reduce((a, c) => a + (+c?.joints || 0), 0);
    // this.netWeight = details[0].netWeight; // details.reduce((a, c) => c.netWeight, 0);
    // this.grossWeight = details[0].grossWeight; // details.reduce((a, c) => c.grossWeight, 0);
  }
}

@Component({
  selector: 'ngx-box-label',
  templateUrl: './box-label.component.html',
  styleUrls: ['./box-label.component.css']
})
export class BoxLabelComponent implements AfterViewInit, OnChanges {

  @Input() compilation: CompilationModel;
  @Input() windowed = false;
  @Input() warehousing = false;

  @ViewChild('boxLabel') boxLabel: ElementRef;
  @ViewChild('boxLabelWindow') boxLabelWindow: NrkWindowComponent;

  mongoId = mongoId; // forward to template

  boxes: SpoBoxDetail[];
  boxLabels: SpoBoxDetail[];

  // remarksText: string;
  // remarksFontSize: number = 18;
  // remarksTextCenter = false;
  shelfLifeText: string;
  shelfLifeDate: any;
  shelfLifeMonths: number;
  expiryMonths: number;
  grossWeightOverride: number;
  print = false;
  isPortrait = false;
  isA4 = false;
  showDateOfProd = true;

  applied = false;
  saved = false;

  finishedProductShelfLifeOptions = [];

  // shelfLifeOption = 1;
  
  constructor(
    private api: ApiService,
    protected data: SharedDataService,
    private toastr: NbToastrService,
    private datePipe: DatePipe,
    private cdRef: ChangeDetectorRef,
    protected tree: TreeService,
    private auth: AuthGuardService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.compilation.currentValue) {
      if (!this.compilation.boxLabelConfig) {
        this.compilation.boxLabelConfig = new BoxLabelConfig();
      }  
    }
  }

  // TODO: remove test code
  ngAfterViewInit(): void {
    // this.boxLabelWindow.show(); this.loadData()
    // this.shelfLifeOption = 5;
    // console.log('=======>this.boxLabelConfig', this.compilation.boxLabelConfig);
  }

  // TODO: use instead of productionLotTable, migrate to shared data
  async loadData() {

    const spos = (await this.api.loadCompilationsByCodes(this.compilation.lineItems.flatMap(m => m.pfspo).map(m => m.code))).flat();
    const details = spos.flatMap(m => m.lineItems.map(li => li.boxDetails)).flat();
    const boxIds = Array.from(new Set(this.compilation.packingConditions.flatMap(m => m.items.map(it => it.boxes)).flat())).sort(); 
    const req = await this.api.loadSpoBoxes({ boxId: { $in: boxIds }});
    const lineItems = boxIds.map(m => ({ boxId: m, lineItem: spos.flatMap(s => s.lineItems).find(li => li.boxDetails.find(f => f.boxId === m)) }))

    console.log('lineItems', lineItems, boxIds, spos, details, req, this.compilation.lineItems);
    // console.log('lineItems', this.compilation.lineItems.flatMap(m => m.pfspo), this.compilation.lineItems.flatMap(m => m.pfspo).map(m => m.code));
    
    this.boxes = boxIds.map(box => {
      const theBox = req.find(f => f.boxId === box);
      if (!theBox) return;
      const lineItem = lineItems.find(f => f.boxId === box).lineItem;
      const dnLineItem = this.compilation.lineItems?.find(f => f.position?.internalPos === theBox.docRefPos);
      // console.log('spo lineItem', lineItem, 'dn lineItem', dnLineItem);
      const fp = this.data.finishedProducts?.find(f => mongoId(f) === mongoId(dnLineItem?.finishedProduct || lineItem.finishedProduct));
      if (!fp) return;
      fp.product = this.data.baseProducts.find(f => mongoId(f) === mongoId(fp.product));
      if (fp.content.energy) fp.content.energy.core = this.data.cores.find(f => mongoId(f) === mongoId(fp.content.energy?.core))
      let shelfLifeMonths: number = null;
      let shelfLifeDegrees: number = null;
      let shelfLifeMode: ShelfLifeModeType = null;
      // console.log('box label priority', fp.boxLabelPriority, fp.product.shelfLife20Deg, fp.product.shelfLife10Deg, fp.product.shelfLife5Deg, fp.product.shelfLifeFromDispatch20Deg, fp.product.shelfLifeFromDispatch10Deg, fp.product.shelfLifeFromDispatch5Deg);
      switch (fp.boxLabelPriority) {
        case EBoxLabelPriority.Standard20Deg:
        case EBoxLabelPriority.ExpiryColumn20Deg:
        case EBoxLabelPriority.ExpiryCalculation20Deg:
        // case EBoxLabelPriority.ExpiryFromDispatch20Deg:
          shelfLifeMode = ['standard', 'column', 'calc'][fp.boxLabelPriority - EBoxLabelPriority.Standard20Deg] as ShelfLifeModeType;
          shelfLifeDegrees = 20;
          shelfLifeMonths = fp.product.shelfLife20Deg;
          this.expiryMonths = fp.product.shelfLife20Deg;
          break;
        case EBoxLabelPriority.Standard10Deg:
        case EBoxLabelPriority.ExpiryColumn10Deg:
        case EBoxLabelPriority.ExpiryCalculation10Deg:
        // case EBoxLabelPriority.ExpiryFromDispatch10Deg:
          shelfLifeMode = ['standard', 'column', 'calc'][fp.boxLabelPriority - EBoxLabelPriority.Standard10Deg]as ShelfLifeModeType;
          shelfLifeDegrees = 10;
          shelfLifeMonths = fp.product.shelfLife10Deg;
          this.expiryMonths = fp.product.shelfLife10Deg;
          break;
        case EBoxLabelPriority.Standard5Deg:
        case EBoxLabelPriority.ExpiryColumn5Deg:
        case EBoxLabelPriority.ExpiryCalculation5Deg:
        // case EBoxLabelPriority.ExpiryFromDispatch5Deg:
          shelfLifeMode = ['standard', 'column', 'calc'][fp.boxLabelPriority - EBoxLabelPriority.Standard5Deg] as ShelfLifeModeType;
          shelfLifeDegrees = 5;
          shelfLifeMonths = fp.product.shelfLife5Deg;
          this.expiryMonths = fp.product.shelfLife5Deg;
          break;
      }

      if (+fp.boxLabelPriority >= EBoxLabelPriority.ExpiryFromDispatch5Deg && +fp.boxLabelPriority <= EBoxLabelPriority.ExpiryFromDispatch20Deg) {
        shelfLifeMode = 'calc';
        if (+fp.boxLabelPriority === EBoxLabelPriority.ExpiryFromDispatch20Deg) {
          shelfLifeDegrees = 20;
          shelfLifeMonths = fp.product.shelfLifeFromDispatch20Deg;
          this.expiryMonths = fp.product.shelfLifeFromDispatch20Deg;
        } else if (+fp.boxLabelPriority === EBoxLabelPriority.ExpiryFromDispatch10Deg) {
          shelfLifeDegrees = 10;
          shelfLifeMonths = fp.product.shelfLifeFromDispatch10Deg;
          this.expiryMonths = fp.product.shelfLifeFromDispatch10Deg;
        } else if (+fp.boxLabelPriority === EBoxLabelPriority.ExpiryFromDispatch5Deg) {
          shelfLifeDegrees = 5;
          shelfLifeMonths = fp.product.shelfLifeFromDispatch5Deg;
          this.expiryMonths = fp.product.shelfLifeFromDispatch5Deg;
        }
      }

      // console.log('shelflife boxLabelPriority', fp.boxLabelPriority, shelfLifeMode, shelfLifeDegrees, shelfLifeMonths, this.expiryMonths);

      // if (fp.product?.shelfLife20Deg) { shelfLifeMonths = fp.product.shelfLife20Deg; shelfLifeDegrees = 20; }
      // if (fp.product?.shelfLife10Deg) { shelfLifeMonths = fp.product.shelfLife10Deg; shelfLifeDegrees = 10; }
      // if (fp.product?.shelfLife5Deg) { shelfLifeMonths = fp.product.shelfLife5Deg; shelfLifeDegrees = 5; }
      this.finishedProductShelfLifeOptions[mongoId(fp)] = { 
        name: fp.calcName, 
        product: fp.product,
        mode: shelfLifeMode,
        degrees: shelfLifeDegrees, 
        months: shelfLifeMonths 
      };

      // console.log('box-label', shelfLifeMode, shelfLifeDegrees, shelfLifeMonths, this.shelfLifeDate, this.finishedProductShelfLifeOptions);

      return new SpoBoxDetail(
        this.compilation,
        theBox,
        spos.find(f => f.code === theBox.spo),
        details.filter(f => f.boxId === box),
        lineItem,
        dnLineItem,
        fp,
        this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))
      )
    }).sort((a: SpoBoxDetail, b: SpoBoxDetail) => a.boxId - b.boxId).sort((a: SpoBoxDetail, b: SpoBoxDetail) => (+a.box.palletRef) - (+b.box.palletRef));

    console.log('lineItemsBoxes', this.boxes);

    this.boxLabels = [];
    const maxChunks = 5;
    for (const box of this.boxes) {
      if (box.details?.length > maxChunks)  {
        chunkArray(box.details, maxChunks).forEach((chunk, i) => {
          const newBox = JSON.parse(JSON.stringify(box));
          newBox.details = chunk;
          newBox.box.case = `${box.box.case}-${i + 1}`;
          newBox.el = i+1;
          newBox.of = Math.ceil(box.details.length / maxChunks); 
          this.boxLabels.push(newBox);
        })
      } else {
        this.boxLabels.push(box);
      }
    }

    // this.boxLabels = this.boxLabels.sort((a: SpoBoxDetail, b: SpoBoxDetail) => a.boxId - b.boxId).sort((a: SpoBoxDetail, b: SpoBoxDetail) => (+a.box.palletRef) - (+b.box.palletRef));

    if (this.compilation.boxLabelConfig.mode !== 2) {
      this.applyShelfLifeText(true);
    }

    // console.log('BoxLabel: loadData', spos, details, boxIds, req, lineItems, this.boxes, this.finishedProductShelfLifeOptions, this.shelfLifeOption);
  }

  checkValid(withMessage = false) {
    switch (this.compilation.boxLabelConfig?.mode) {
      case 1: 
        if (Object.values(this.finishedProductShelfLifeOptions).find(f => !f.degrees || !f.months)) {
          // console.log('finishedProductShelfLifeOptions', Object.values(this.finishedProductShelfLifeOptions));
          if (withMessage) this.toastr.danger('Degrees and/or Months are missing', 'Shelf Life Override');
          return false;
        }
        return true;
      case 2:
        if (!this.shelfLifeText) {
          if (withMessage) this.toastr.danger('Shelf Life Text is missing', 'Shelf Life Override');
          return false;
        }
        return true;
      case 3:
      case 5:
        return true;
      case 4:
      case 8:
        if (!this.expiryMonths) {
          if (withMessage) this.toastr.danger('Expiry Month is missing', 'Expiry Dates');
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  checkDisabled(section: string) {
    // console.log('check valid', this.checkValid());
    const keep = this.compilation.boxLabelConfig?.mode === 5;
    if ([6,7].includes(this.compilation.boxLabelConfig?.mode)) return null;
    switch (section) {
      case 'apply':
        // console.log('apply', !this.checkValid)
        if (keep || !this.checkValid()) return true;
        break;
      case 'save':
        if (!keep && (!this.checkValid() || !this.applied)) return true;
        break;
      case 'download':
        if (!keep && (!this.checkValid() || !this.saved)) return true;
        break;
    }
    // console.log('check disabled, null');
    return null;
  }

  async applyShelfLifeText(initial = false) {
    const saveInitialBoxes = [];
    const targets = [...new Set([...this.boxes, ...this.boxLabels])];
    targets.forEach(box => {
      const degrees = this.finishedProductShelfLifeOptions[mongoId(box.finishedProduct)].degrees;
      const months = this.finishedProductShelfLifeOptions[mongoId(box.finishedProduct)].months;
      const mode: ShelfLifeModeType = this.finishedProductShelfLifeOptions[mongoId(box.finishedProduct)].mode;

      // console.log('applyShelfLifeText', mode, this.compilation.boxLabelConfig?.mode, box.finishedProduct);
      if (initial && this.compilation.boxLabelConfig?.mode) {
        // if (!box.finishedProduct.boxLabelPriority && degrees && months) this.compilation.boxLabelConfig.mode = 1;
        // else if (box.finishedProduct.boxLabelPriority === EBoxLabelPriority.ExpiryColumn) this.compilation.boxLabelConfig.mode = 3;
        // else if (box.finishedProduct.boxLabelPriority === EBoxLabelPriority.ExpiryCalculation) this.compilation.boxLabelConfig.mode = 4;
        // console.log('apply shelf life initial', this.compilation.boxLabelConfig.mode, box);
        if (this.compilation.boxLabelConfig.mode !== 2) {
          if (mode === 'standard') this.compilation.boxLabelConfig.mode = 1;
          else if (mode === 'column') this.compilation.boxLabelConfig.mode = 3;
          else if (mode === 'calc') this.compilation.boxLabelConfig.mode = 4;
          if (box.finishedProduct.boxLabelPriority >= +EBoxLabelPriority.ExpiryFromDispatch5Deg && box.finishedProduct.boxLabelPriority <= +EBoxLabelPriority.ExpiryFromDispatch20Deg) {
            this.compilation.boxLabelConfig.mode = 8;
            // console.log('applyShelfLifeText priority', box.finishedProduct.boxLabelPriority, this.compilation.boxLabelConfig, this.expiryMonths);
          }
        }
        saveInitialBoxes.push(box);
      }
      switch (this.compilation.boxLabelConfig?.mode) {
        case 1: 
          box.box.shelfLifeText = `Min shelf life at ${degrees} °C: ${months} months`;
          box.box.shelfLifeDate = this.shelfLifeDate;
          break;
        case 2:
          box.box.shelfLifeText = this.shelfLifeText;
          box.box.shelfLifeDate = this.shelfLifeDate;
          break;
        case 3:
          box.box.shelfLifeText = `Storage conditions: ${degrees} °C`;
          box.details.forEach(el => {
            if (!el.expiryDate) {
              el.expiryDate = moment(el.prodDate).add(this.expiryMonths, 'months').toDate()
            }
          });
          break;
        case 4:
          box.box.shelfLifeText = `Storage conditions: ${degrees} °C`;
          // console.log('box- expiry months', this.expiryMonths);
          box.details.forEach(el => el.expiryDate = moment(el.prodDate).add(this.expiryMonths, 'months').toDate());
          break;
        case 6:
        case 7:
          box.box.remarks = this.compilation.boxLabelConfig.remarks;
          break;
        case 8:
          const dispatch = box.oc.vieDispatchDate;
          box.box.shelfLifeText = `Shelf Life: ${this.expiryMonths} months after date of dispatch at ${degrees} °C\nDate of dispatch: ${this.datePipe.transform(dispatch, 'MMM yyyy')}`;
          // console.log('box- expiry months', box.box?.dispatchDate, box.oc.vieDispatchDate, this.expiryMonths, box);
          box.details.forEach(el => el.expiryDate = moment(dispatch).add(this.expiryMonths, 'months').toDate());
          break;
        }

      // console.log('--box--', this.shelfLifeText, this.shelfLifeDate, this.compilation.boxLabelConfig?.mode, box.box)

      box.box.grossWeightOverride = this.grossWeightOverride;

    })

    this.applied = true;

    const tmp = await this.api.loadCompilationByCode(this.compilation.code);
    tmp.boxLabelConfig = this.compilation.boxLabelConfig;
    this.api.saveCompilation(tmp);

    if (saveInitialBoxes.length) {
      this.saveBoxes();
    }
    
  }

  printLabels() {

    this.print = true;

    this.cdRef.detectChanges();
    
    const config = new DownloadConfig();
    // config.css = 'document-printer.css';
    config.cssFiles = ['box-label.component.css'];
    config.footer = ''
    config.html = this.boxLabel.nativeElement.innerHTML;
    if (!this.isA4) config.orientation =  'landscape';
    config.pageSize = this.isA4 ? 'A4' : 'A5';
    config.nofooter = true;
    config.noheader = true;
    config.nomargin = true;

    this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
      
      const date = this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
      const docnum = getDocumentNumber(this.compilation);
      const company = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))?.name
      await this.data.loadBusinesses();
      if (res.size) saveAs(res, `${date}_${company}_${docnum}_Boxlabels.pdf`);
      this.print = false;
      
      PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Print Box Labels');

      this.cdRef.detectChanges();
      
    });

  }

  async saveBoxes() {
    const boxes = this.boxes.map(m => m.box);
    this.api.saveSpoBoxes(boxes).then(() => {
      this.toastr.success(`${boxes.length} boxes successfully saved`,'Save Boxes')
    });
    const spos = Array.from(new Set(this.boxes.map(m => m.spo?.code)));
    for (const spo of spos) {
      const doc = await this.api.loadCompilationByCode(spo);
      doc.lineItems.forEach(el => {
        el.boxDetails.forEach(bd => {
          const ref = this.boxes.find(f => f.boxId === bd.boxId);
          const refCase = ref?.details.find(f => f.case === bd.case);
          if (refCase?.expiryDate) bd.expiryDate = refCase.expiryDate;
        })
      })
      console.log('save boxes / compilation', doc);
      await this.api.saveCompilation(doc);
    }
    this.saved = true;
  }

  getLm(item: SpoBoxDetail, details: BoxDetails) {
    return details.quantity * (item.finishedProduct?.content?.energy?.rollLength || 0);
  }
  getSqm(item: SpoBoxDetail) {
    const prod = item.finishedProduct?.content?.energy;
    const quantity = this.getSumQuantity(item) || 0;
    // return Math.round(quantity * (prod?.rollLength || 0) * (prod?.width / 1000 || 0));
    // console.log('getSqm', quantity, prod.rollLength, prod.width/1000, quantity * (prod?.rollLength || 0) * (prod?.width / 1000 || 0), (quantity * (prod?.rollLength || 0) * (prod?.width / 1000 || 0)).toFixed(1));
    return (quantity * (prod?.rollLength || 0) * (prod?.width / 1000 || 0)).toFixed(1);
  }

  getSumQuantity(item: SpoBoxDetail) {
    return item.details?.reduce((a, c) => a + (c?.quantity || 0), 0);
  }

  getSumLm(item: SpoBoxDetail) {
    return item.details.reduce((a, c) => a + this.getLm(item, c), 0);
  }

  selectAll() {
    this.boxes.forEach(box => box.selected = true);
  }

  selectNone() {
    this.boxes.forEach(box => box.selected = false);
  }

  getNetWeight(item: SpoBoxDetail) {
    const width = item.finishedProduct?.content?.energy?.width / 1000; // mm -> m
    const length = item.finishedProduct?.content?.energy?.rollLength; // m
    const areaWeight = item.finishedProduct?.product?.weight / 1000; // g -> kg
    const quantity = item.details?.reduce((a, c) => a + (c?.quantity || 0), 0);
    console.log('width len,,,', width, length, areaWeight, quantity)
    try {
      return quantity * width * length * areaWeight;
    } catch (e) {
      return 0;
    }
  }

  // getGrossWeight(item: SpoBoxDetail) {
  //   return item.box.grossWeightOverride || item.details[0]?.grossWeight || 0;
  // }

  // getExpiryDate(item: BoxDetails) {
  //   if (this.shelfLifeOption === 3) {
  //     return item.expiryDate;
  //   } else {
  //     return moment(item.prodDate).add(this.expiryMonths, 'months').toDate();
  //   }
  // }

}
